var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbuse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2,.st5{stroke-linecap:round}.st2{fill:none;stroke:#175b3e;stroke-linejoin:round;stroke-miterlimit:2.6131;stroke-width:3}.st5{stroke-width:2}.st5,.st6{fill:none;stroke:#2ec986;stroke-miterlimit:2.6131}.st6,.st8,.st9{stroke-linejoin:round}.st8{fill:none;stroke-width:2;stroke:#175b3e;stroke-miterlimit:2.6131}.st9{stroke:#fff;stroke-miterlimit:10}.st10,.st11,.st9{fill:none;stroke-width:2;stroke-linecap:round}.st10{stroke-linejoin:round;stroke-miterlimit:2.6131;stroke:#175b3e}.st11{stroke:#42a87c}.st13{opacity:.15}.st13,.st14{fill:#2ec986}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "object"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117 111l-11.5-43.2L94 24.6c-.2-.9-1.4-1-1.8-.2C79.3 48.1 69.1 57.3 57 61c0 0-24.7 6.6-31.7 8.4-2.5.7-4 3-3.4 5.2l.4 1.4-2 .5c-2.3.6-3.7 2.7-3.1 4.7l.6 2.3 3.7 14 .6 2.3c.5 2 2.8 3.1 5 2.5l2-.5.4 1.4c.6 2.2 3.1 3.4 5.5 2.8 1.9-.5 5.1-1.3 8.7-2.3l1.1 5.7 9.8 16.6c.7 1.2 2.2 1.8 3.6 1.5l9.1-2.4c1.4-.4 2-2 1.2-3.2l-10.7-15.8-.5-5.9c5.4-1.4 9.5-2.5 9.5-2.5 12.3-2.7 25.8.1 48.8 14.4.7.5 1.6-.2 1.4-1.1z",
    opacity: 0.19,
    fill: "#2ec986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8 99.9l1.4 7.3 9.8 16.6c.7 1.2 2.2 1.8 3.6 1.5l9.1-2.4c1.4-.4 2-2 1.2-3.2l-10.7-15.8-.7-7.4-13.7 3.4z",
    fill: "#f6fdfa"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.1 118.9l2.9 4.9c.7 1.2 2.2 1.8 3.6 1.5l9.1-2.4c1.4-.4 2-2 1.2-3.2l-10.7-15.8-.7-7.4-13.6 3.6 1.4 7.3 1.3 2.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-30.56 45.318 114.157)",
    cx: 45.3,
    cy: 114.2,
    rx: 1.5,
    ry: 1.5,
    fill: "none",
    stroke: "#175b3e",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.3 79.2c3.8-3 5.3-9.7 3.5-16.7s-6.5-12-11.3-12.8",
    fill: "#f6fdfa",
    stroke: "#175b3e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110 48.7c7.3 5.3 10.3 16.3 6.5 24.6M120.3 37.3c11.7 11.3 15.9 30.6 9.2 45.4M116.6 34.1l1.2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M126.3 72.5l-1.9-.3M125.8 74.8l-1.9-.5M125 77.1l-1.8-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M113.5 40.9c9 6.5 13.6 18.7 12.1 29.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3 94l.6 2.3c.5 2 2.8 3.1 5 2.5l2-.5.4 1.4c.6 2.2 3.1 3.4 5.5 2.8 6.9-1.8 31.7-8.4 31.7-8.4 12.7-2.8 26.6.3 50.9 15.7l-12.1-45.6-12.1-45.6c-13.5 25.4-24 35-36.4 38.9 0 0-24.7 6.6-31.7 8.4-2.5.7-4 3-3.4 5.2l.4 1.4-2 .5c-2.3.6-3.7 2.7-3.1 4.7l.6 2.3 3.7 14z",
    fill: "#e6f9f0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M80 37.3l-4.1-2.9M76.1 42.5l-3.9-3.1M71.8 47.5L68.2 44"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.1 49.4c-4.7 4-9.3 6.5-14.3 8.1 0 0-24.7 6.6-31.7 8.4-2.5.7-4 3-3.4 5.2l.4 1.4-2 .5c-2.3.6-3.7 2.7-3.1 4.7l.6 2.3 3.7 14 .6 2.3c.5 2 2.8 3.1 5 2.5l2-.5.4 1.4c.6 2.2 3.1 3.4 5.5 2.8 6.9-1.8 31.7-8.4 31.7-8.4 12.7-2.8 26.6.3 50.9 15.7l-12.1-45.6-12.1-45.6c-2.5 4.8-5 9-7.4 12.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M79.7 42c2.3-3 4.5-6.4 6.8-10.1M20.3 89.5l-3.1-11.8 6-1.6-1.4-5.4 4.5-1.2 26.9-7.2h.1c8.8-2.7 16.4-8.1 23.8-17.1M21.5 93.8l-.4-1.4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sparkles"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M20 129.6l-1.5-2.6M12.6 128.8l2-2.2M11.1 121.6l2.7 1.2M17.5 117.9l-.3 3M23 122.8l-3 .7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.1 20.6c-1.1 2.2-3.4 3.7-5.8 4M21.7 23.8c-2.2-1.1-3.7-3.4-4-5.8M18.5 13.4c1.1-2.2 3.4-3.7 5.8-4M28.9 10.3c2.2 1.1 3.7 3.4 4 5.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.9 118.2c-.7 0-3.1 2.4-3.1 3.1 0-.7-2.4-3.1-3.1-3.1.7 0 3.1-2.4 3.1-3.1 0 .7 2.4 3.1 3.1 3.1z",
    fill: "#dfab29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 134.4,
    cy: 129.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 133,
    cy: 128.3,
    r: 3.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 9,
    cy: 50.3,
    r: 1.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 62.4,
    cy: 29.5,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 61.1,
    cy: 28.3,
    r: 3.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbuse);
export default __webpack_public_path__ + "static/media/abuse.b927b4399ac4edbf89bb7f87c00a25ba.svg";
export { ForwardRef as ReactComponent };